import React, { Component } from "react";
import { Link } from "react-router-dom";
import Information from "../Information";
import Store from "../../../content/Store";
import Content from "../../../content/Content";
import { Paths } from "../../../constants/UrlConstants";

export class PageNotFound extends Component {
  render() {
    return (
      <Information headerText={Store.ErrorPages.PageNotFound.HeaderText}>
        <Content name={Store.ErrorPages.PageNotFound.Message} />
        <p>
          <Link to={Paths.HomeRoot}>
            <Content name={Store.ErrorPages.PageNotFound.Link} />
          </Link>
        </p>
      </Information>
    );
  }
}

export default PageNotFound;
